import { Component, OnInit, OnDestroy, NgZone, ViewChild, EventEmitter, Input} from '@angular/core';

import { Subscription } from 'rxjs';
import { ModalDirective } from 'ngx-bootstrap/modal';

import {
    ToastrService,
    PartsManualService,
    ModelService,
    MinesiteService,
    Model,
    Company,
    Minesite,
    PoweredBy,
    Equipment
} from './../../../shared/index';


@Component({
    selector: 'partsmanual-list',
    templateUrl: './partsmanual-list.html',
    standalone: false
})

export class PartsManualListComponent implements  OnDestroy {
    @ViewChild('URLChange') modal: ModalDirective;
    @ViewChild('partsmanualFilter') filterModal: ModalDirective;
    private subscriptions: Subscription[] = [];

    public equipments: Equipment[];
    public models: Model[] = [];
    public poweredBys: PoweredBy[] = [];
    public companies: Company[] = [];
    public minesites: Minesite[] = [];

    public filterApplied = false;

    public serial = '';
    public selectedModel: number = null;
    public selectedPoweredBy: number = null;
    public selectedCompany: number = null;
    public selectedMinesite: number = null;

    constructor(
        private _ngZone: NgZone,
        private _partsManualService: PartsManualService,
    ) {

        this.subscriptions.push(this._partsManualService.equipmentChange.subscribe((info: any) => {
            this._ngZone.run(() => {
                this.equipments = info;
            });
        }));
        this.subscriptions.push(this._partsManualService.modelChange.subscribe((info: any) => {
            this._ngZone.run(() => {
                this.models = info;
            });
        }));
        this.subscriptions.push(this._partsManualService.powerdByChange.subscribe((info: any) => {
            this._ngZone.run(() => {
                this.poweredBys = info;
            });
        }));
        this.subscriptions.push(this._partsManualService.minesiteChange.subscribe((info: any) => {
            this._ngZone.run(() => {
                this.minesites = info;
            });
        }));
        this.subscriptions.push(this._partsManualService.companyChange.subscribe((info: any) => {
            this._ngZone.run(() => {
                this.companies = info;
            });
        }));
        this._partsManualService.getAllEquipments(this.selectedModel, this.selectedPoweredBy, this.selectedCompany, this.selectedMinesite, this.serial);
        this._partsManualService.getAllModels();

    }

    public showModal(serial: string, partsManualURL: string, edManualURL: string): void {
        const serialnum = document.getElementById('serialModal');
        serialnum.innerText = serial;
        (<HTMLInputElement>document.getElementById('partsManualURLModal')).value = partsManualURL == undefined ? '' : partsManualURL;
        (<HTMLInputElement>document.getElementById('edManualURLModal')).value = edManualURL == undefined ? '' : edManualURL;
        this.modal.show();
    }

    public closeModal() {
        this.modal.hide();
    }

    public submitURLChange() {
        this.modal.hide();
        this._partsManualService.saveURL(document.getElementById('serialModal').innerText, (<HTMLInputElement>document.getElementById('partsManualURLModal')).value, (<HTMLInputElement>document.getElementById('edManualURLModal')).value, this.selectedModel, this.selectedPoweredBy, this.selectedCompany, this.selectedMinesite, this.serial);
    }

    public getPoweredByForModel(): void {
        $('#selectedPowereBysFilter option').remove();
        $('#selectedMinesitesFilter option').remove();
        $('#selectedCompaniesFilter option').remove();
        this.selectedPoweredBy = null;
        this.selectedCompany = null;
        this.selectedMinesite = null;
        this.selectedModel = parseInt($('#selectedModelsFilter option:selected')[0].id);
        this._partsManualService.getPoweredByForModel(this.selectedModel);
    }

    public getCompanyForModelAndPoweredBy(): void {
        $('#selectedCompaniesFilter option').remove();
        $('#selectedMinesitesFilter option').remove();
        this.selectedCompany = null;
        this.selectedMinesite = null;
        this.selectedPoweredBy = parseInt($('#selectedPowereBysFilter option:selected')[0].id);

        this._partsManualService.getCompaniesByModelAndPoweredBy(this.selectedModel, this.selectedPoweredBy);
    }

    public getMinesitesForModelAndPoweredByAndCompany(): void {
        $('#selectedMinesitesFilter option').remove();
        this.selectedMinesite = null;
        this.selectedCompany = parseInt($('#selectedCompaniesFilter option:selected')[0].id);

        this._partsManualService.getMinesitesByModelAndPoweredByAndCompany(this.selectedModel, this.selectedPoweredBy, this.selectedCompany);
    }

    public minesiteSelected(): void {
        this.selectedMinesite = parseInt($('#selectedMinesitesFilter option:selected')[0].id);
    }

    public showFilters(): void {
        this.filterModal.show();
    }

    public applyFilter(): void {
        this.serial = (<HTMLInputElement>document.getElementById('serialFilter')).value;
        if (this.serial != '' || this.selectedModel != null || this.selectedPoweredBy != null || this.selectedMinesite != null || this.selectedCompany != null) {
            this.filterApplied = true;
        }
        else {
            this.filterApplied = false;
        }
         this._partsManualService.getAllEquipments(this.selectedModel, this.selectedPoweredBy, this.selectedCompany, this.selectedMinesite, this.serial);
        this.filterModal.hide();
    }

    public close(): void {
        this.filterModal.hide();
    }

    public clearFilter(): void {
        $('#selectedModelsFilter').val([]);
        $('#selectedPowereBysFilter option').remove();
        $('#selectedMinesitesFilter option').remove();
        $('#selectedCompaniesFilter option').remove();
        this.selectedModel = null;
        this.selectedPoweredBy = null;
        this.selectedCompany = null;
        this.selectedMinesite = null;
        this.serial = '';
        this.filterApplied = false;
        this._partsManualService.getAllEquipments(this.selectedModel, this.selectedPoweredBy, this.selectedCompany, this.selectedMinesite, this.serial);
        this.filterModal.hide();
    }

    public populateEDURL(): void {
        (<HTMLInputElement>document.getElementById('edManualURLModal')).value = (<HTMLInputElement>document.getElementById('partsManualURLModal')).value.trim() + 'ED';
    }

    ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }


}
